export function sellersPropertyDisclosureCommercial2026() {
return [   // Release 2025-12-31 09:24:42
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date SPD completed by Seller", 
   fontSize: 9,
   type: "date",
   top: 481.4,
   left: 199.44,
   width: 349.56,
   height: 11.804
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 499.28,
   left: 111.6,
   width: 437.4,
   height: 11.804
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 517.28,
   left: 111.12,
   width: 437.88,
   height: 11.804
}
,
{
   page: 0,
   name: "Year Built", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 535.28,
   left: 119.28,
   width: 429.72,
   height: 11.804
}
,
{
   page: 0,
   name: "Year Seller Acquired Property", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 553.04,
   left: 199.2,
   width: 349.8,
   height: 11.804
}
,
{
   page: 0,
   name: "If Seller is not currently occupying the property date Seller last occupied the Property", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 588.32,
   left: 419.52,
   width: 151.102,
   height: 11.149
}
,
{
   page: 0,
   name: "Check Box58", 
   isText: false,
   type: "checkbox",
   top: 608.075,
   left: 400.584,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Check Box59", 
   isText: false,
   type: "checkbox",
   top: 608.73,
   left: 450.984,
   width: 10.080,
   height: 10.08
}
,
{
   page: 0,
   name: "Check Box60", 
   isText: false,
   type: "checkbox",
   top: 574.039,
   left: 98.1823,
   width: 10.0797,
   height: 10.080
}
,
{
   page: 0,
   name: "Check Box61", 
   isText: false,
   type: "checkbox",
   top: 573.384,
   left: 128.946,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "YesStructural problems with improvements", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 93.72,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "YesStructural supports or reinforcements added", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 128.76,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "YesMoisture andor water including but not limited to leakageseepage in the basementcrawlspace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 161.88,
   left: 259.488,
   width: 318.852,
   height: 35.88
}
,
{
   page: 1,
   name: "YesDamage due to termites other insects birds animals or rodents", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 201.24,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "YesDamage due to hail wind fire flood or other casualty", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 236.16,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "YesAny settling movement cracking heaving or breakage of the following", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 271.08,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "Yesa Foundations", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 306.12,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "Yesb Floors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 341.16,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "Yesc Interior Walls", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 376.2,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "Yesd Exterior Walls", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 411.24,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "Yese Driveways", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 446.16,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "Yesf Sidewalks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 481.08,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "Yesg Patios", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 516.12,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "Yesh Retaining Walls", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 551.16,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "Yesi Other", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 586.2,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "YesWindow Leaks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 621.12,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "YesExterior Artificial Stucco EIFS", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 656.04,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "YesSubfloors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 691.08,
   left: 259.488,
   width: 318.852,
   height: 30.12
}
,
{
   page: 1,
   name: "Subfloors10", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 724.2,
   left: 53.76,
   width: 174.60,
   height: 26.52
}
,
{
   page: 1,
   name: "Yes10", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 724.2,
   left: 259.488,
   width: 318.852,
   height: 26.52
}
,
{
   page: 1,
   name: "Check Box62", 
   isText: false,
   type: "checkbox",
   top: 103.717,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box63", 
   isText: false,
   type: "checkbox",
   top: 138.747,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box64", 
   isText: false,
   type: "checkbox",
   top: 175.151,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box65", 
   isText: false,
   type: "checkbox",
   top: 217.737,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box66", 
   isText: false,
   type: "checkbox",
   top: 239.716,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box67", 
   isText: false,
   type: "checkbox",
   top: 282.423,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box68", 
   isText: false,
   type: "checkbox",
   top: 313.211,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box69", 
   isText: false,
   type: "checkbox",
   top: 350.302,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box70", 
   isText: false,
   type: "checkbox",
   top: 383.272,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box71", 
   isText: false,
   type: "checkbox",
   top: 418.302,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box72", 
   isText: false,
   type: "checkbox",
   top: 454.019,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box73", 
   isText: false,
   type: "checkbox",
   top: 489.049,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box74", 
   isText: false,
   type: "checkbox",
   top: 517.211,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box75", 
   isText: false,
   type: "checkbox",
   top: 554.988,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box76", 
   isText: false,
   type: "checkbox",
   top: 597.574,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box77", 
   isText: false,
   type: "checkbox",
   top: 626.422,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box78", 
   isText: false,
   type: "checkbox",
   top: 663.513,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box79", 
   isText: false,
   type: "checkbox",
   top: 699.2302,
   left: 239.03,
   width: 10.08,
   height: 10.0800
}
,
{
   page: 1,
   name: "Check Box80", 
   isText: false,
   type: "checkbox",
   top: 727.3917,
   left: 239.03,
   width: 10.08,
   height: 10.0800
}
,
{
   page: 2,
   name: "CommentsIndicate age of roof in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 102.36,
   left: 258,
   width: 321.24,
   height: 36.60
}
,
{
   page: 2,
   name: "CommentsIndicate roof material in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 140.76,
   left: 258,
   width: 321.24,
   height: 36.60
}
,
{
   page: 2,
   name: "CommentsRoof is under warranty", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 179.16,
   left: 258,
   width: 321.24,
   height: 36.84
}
,
{
   page: 2,
   name: "Commentsa Date of warranty expiration", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 217.8,
   left: 258,
   width: 321.24,
   height: 36.6
}
,
{
   page: 2,
   name: "Yes No UnknownRoof work done while under current roof warranty", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 300.84,
   left: 258,
   width: 321.24,
   height: 36.60
}
,
{
   page: 2,
   name: "Yes No Unknowna Date work completed", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 339.24,
   left: 258,
   width: 321.24,
   height: 36.84
}
,
{
   page: 2,
   name: "a Date work completed5", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 377.88,
   left: 54,
   width: 174.12,
   height: 49.08
}
,
{
   page: 2,
   name: "Yes No Unknown5", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 377.88,
   left: 258,
   width: 321.24,
   height: 49.08
}
,
{
   page: 2,
   name: "CommentsRoof leak", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 462.84,
   left: 258,
   width: 321.24,
   height: 36.84
}
,
{
   page: 2,
   name: "CommentsDamage to roof", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 501.48,
   left: 258,
   width: 321.24,
   height: 36.60
}
,
{
   page: 2,
   name: "CommentsDamage to skylight", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 539.88,
   left: 258,
   width: 321.24,
   height: 36.60
}
,
{
   page: 2,
   name: "CommentsDamage to gutter or downspout", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 578.28,
   left: 258,
   width: 321.24,
   height: 36.60
}
,
{
   page: 2,
   name: "CommentsOther roof problems issues or concerns", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 616.68,
   left: 258,
   width: 321.24,
   height: 36.60
}
,
{
   page: 2,
   name: "Other roof problems issues or concerns11", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 655.08,
   left: 54,
   width: 174.12,
   height: 49.32
}
,
{
   page: 2,
   name: "Comments11", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 655.08,
   left: 258,
   width: 321.24,
   height: 49.32
}
,
{
   page: 2,
   name: "Check Box81", 
   isText: false,
   type: "checkbox",
   top: 112.646,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box82", 
   isText: false,
   type: "checkbox",
   top: 150.424,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box83", 
   isText: false,
   type: "checkbox",
   top: 188.201,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box84", 
   isText: false,
   type: "checkbox",
   top: 265.13,
   left: 236.282,
   width: 10.080,
   height: 10.081
}
,
{
   page: 2,
   name: "Check Box85", 
   isText: false,
   type: "checkbox",
   top: 257.949,
   left: 263.757,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box86", 
   isText: false,
   type: "checkbox",
   top: 257.949,
   left: 290.545,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box87", 
   isText: false,
   type: "checkbox",
   top: 257.949,
   left: 318.019,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box88", 
   isText: false,
   type: "checkbox",
   top: 310.464,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box89", 
   isText: false,
   type: "checkbox",
   top: 344.12,
   left: 236.282,
   width: 10.080,
   height: 10.08
}
,
{
   page: 2,
   name: "Check Box90", 
   isText: false,
   type: "checkbox",
   top: 386.019,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box91", 
   isText: false,
   type: "checkbox",
   top: 470.504,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box92", 
   isText: false,
   type: "checkbox",
   top: 508.968,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box93", 
   isText: false,
   type: "checkbox",
   top: 543.311,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box94", 
   isText: false,
   type: "checkbox",
   top: 585.21,
   left: 236.282,
   width: 10.080,
   height: 10.08
}
,
{
   page: 2,
   name: "Check Box95", 
   isText: false,
   type: "checkbox",
   top: 623.675,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box96", 
   isText: false,
   type: "checkbox",
   top: 661.453,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Text97", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 271.999,
   left: 259.636,
   width: 319.656,
   height: 24.748
}
,
{
   page: 2,
   name: "Check Box11", 
   isText: false,
   type: "checkbox",
   top: 225.819,
   left: 236.947,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "C", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 367.691,
   left: 300.199,
   width: 286.743,
   height: 21.577
}
,
{
   page: 3,
   name: "Yes220 Volt service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 111.84,
   left: 297.833,
   width: 289.970,
   height: 36.96
}
,
{
   page: 3,
   name: "Age if known220 Volt service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 112.2,
   left: 257.76,
   width: 37.08,
   height: 36.6
}
,
{
   page: 3,
   name: "YesRow2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 150.24,
   left: 297.833,
   width: 289.970,
   height: 36.96
}
,
{
   page: 3,
   name: "Age if knownRow2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 150.6,
   left: 257.76,
   width: 37.08,
   height: 36.6
}
,
{
   page: 3,
   name: "YesLandscape lighting", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 188.64,
   left: 297.833,
   width: 289.970,
   height: 37.20
}
,
{
   page: 3,
   name: "Age if knownLandscape lighting", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 189,
   left: 257.76,
   width: 37.08,
   height: 36.84
}
,
{
   page: 3,
   name: "YesElectric provider provide name in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 227.28,
   left: 297.833,
   width: 289.970,
   height: 36.96
}
,
{
   page: 3,
   name: "Age if knownElectric provider provide name in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 227.64,
   left: 257.76,
   width: 37.08,
   height: 36.60
}
,
{
   page: 3,
   name: "YesCableTV provider  provide name in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 265.68,
   left: 297.833,
   width: 289.970,
   height: 36.96
}
,
{
   page: 3,
   name: "Age if knownCableTV provider  provide name in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 266.04,
   left: 257.76,
   width: 37.08,
   height: 36.60
}
,
{
   page: 3,
   name: "YesInternet provider  provide name in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 304.08,
   left: 297.833,
   width: 289.970,
   height: 36.96
}
,
{
   page: 3,
   name: "Age if knownInternet provider  provide name in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 304.44,
   left: 257.76,
   width: 37.08,
   height: 36.60
}
,
{
   page: 3,
   name: "Age if knownSolar panels", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 342.84,
   left: 257.76,
   width: 37.08,
   height: 71.88
}
,
{
   page: 3,
   name: "Output", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 391.08,
   left: 331.68,
   width: 231.96,
   height: 10.44
}
,
{
   page: 3,
   name: "Age if knownWind generators", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 416.52,
   left: 257.76,
   width: 37.08,
   height: 54.60
}
,
{
   page: 3,
   name: "Owned Leased If leased provide the name and contact information of entity leased from", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 442.32,
   left: 297.36,
   width: 291.00,
   height: 28.80
}
,
{
   page: 3,
   name: "Age if knownSecurity system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 472.92,
   left: 257.76,
   width: 37.08,
   height: 54.36
}
,
{
   page: 3,
   name: "Owned Leased If leased provide the name and contact information of entity leased from_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 498.48,
   left: 297.36,
   width: 291.00,
   height: 28.80
}
,
{
   page: 3,
   name: "Age if knownDoorbell", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 530.28,
   left: 257.52,
   width: 37.56,
   height: 29.88
}
,
{
   page: 3,
   name: "Wired Wireless Smart", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 539.04,
   left: 297.24,
   width: 291.24,
   height: 22.32
}
,
{
   page: 3,
   name: "Age if knownSmokeFire Detectors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 562.92,
   left: 257.52,
   width: 37.56,
   height: 26.76
}
,
{
   page: 3,
   name: "Battery Hardwire", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 573.12,
   left: 297,
   width: 291.72,
   height: 16.56
}
,
{
   page: 3,
   name: "Age if knownCarbon Monoxide Alarms", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 591.24,
   left: 257.52,
   width: 37.56,
   height: 26.52
}
,
{
   page: 3,
   name: "Battery Hardwire_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 601.2,
   left: 297,
   width: 291.72,
   height: 16.56
}
,
{
   page: 3,
   name: "Age if knownInternet Wiring", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 619.56,
   left: 257.76,
   width: 37.08,
   height: 44.76
}
,
{
   page: 3,
   name: "Cable DSL Satellite Fiber Other", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 644.029,
   left: 297.12,
   width: 291.48,
   height: 19.637
}
,
{
   page: 3,
   name: "undefined", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 631.08,
   left: 339.84,
   width: 214.92,
   height: 10.44
}
,
{
   page: 3,
   name: "Age if knownBuilt In Sound System", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 666.12,
   left: 257.76,
   width: 37.08,
   height: 50.28
}
,
{
   page: 3,
   name: "Built In Sound System15", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 717.96,
   left: 54.72,
   width: 173.64,
   height: 26.76
}
,
{
   page: 3,
   name: "Age if known15", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 717.96,
   left: 257.52,
   width: 37.56,
   height: 26.76
}
,
{
   page: 3,
   name: "SpeakersBuilt In WiringBuilt In Speakers Wireless15", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 717.96,
   left: 297.36,
   width: 291.00,
   height: 26.76
}
,
{
   page: 3,
   name: "Check Box98", 
   isText: false,
   type: "checkbox",
   top: 125.01,
   left: 238.343,
   width: 10.080,
   height: 10.08
}
,
{
   page: 3,
   name: "Check Box99", 
   isText: false,
   type: "checkbox",
   top: 157.292,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box100", 
   isText: false,
   type: "checkbox",
   top: 197.818,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box101", 
   isText: false,
   type: "checkbox",
   top: 240.403,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box102", 
   isText: false,
   type: "checkbox",
   top: 276.807,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box103", 
   isText: false,
   type: "checkbox",
   top: 313.898,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box104", 
   isText: false,
   type: "checkbox",
   top: 357.857,
   left: 238.343,
   width: 10.080,
   height: 10.081
}
,
{
   page: 3,
   name: "Check Box105", 
   isText: false,
   type: "checkbox",
   top: 344.494,
   left: 303.908,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box106", 
   isText: false,
   type: "checkbox",
   top: 344.494,
   left: 345.807,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box107", 
   isText: false,
   type: "checkbox",
   top: 424.484,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box108", 
   isText: false,
   type: "checkbox",
   top: 418.989,
   left: 302.908,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box109", 
   isText: false,
   type: "checkbox",
   top: 418.989,
   left: 344.807,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box110", 
   isText: false,
   type: "checkbox",
   top: 480.12,
   left: 238.343,
   width: 10.080,
   height: 10.08
}
,
{
   page: 3,
   name: "Check Box111", 
   isText: false,
   type: "checkbox",
   top: 474.625,
   left: 302.908,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box112", 
   isText: false,
   type: "checkbox",
   top: 473.938,
   left: 345.494,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box113", 
   isText: false,
   type: "checkbox",
   top: 534.382,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box114", 
   isText: false,
   type: "checkbox",
   top: 529.322,
   left: 301.848,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box115", 
   isText: false,
   type: "checkbox",
   top: 529.322,
   left: 339.999,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box116", 
   isText: false,
   type: "checkbox",
   top: 529.322,
   left: 385.332,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box117", 
   isText: false,
   type: "checkbox",
   top: 568.039,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box118", 
   isText: false,
   type: "checkbox",
   top: 563.291,
   left: 302.221,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box119", 
   isText: false,
   type: "checkbox",
   top: 563.291,
   left: 344.12,
   width: 10.08,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box120", 
   isText: false,
   type: "checkbox",
   top: 595.513,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box121", 
   isText: false,
   type: "checkbox",
   top: 591.14,
   left: 303.595,
   width: 10.080,
   height: 10.08
}
,
{
   page: 3,
   name: "Check Box122", 
   isText: false,
   type: "checkbox",
   top: 591.766,
   left: 343.433,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box123", 
   isText: false,
   type: "checkbox",
   top: 626.422,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box124", 
   isText: false,
   type: "checkbox",
   top: 619.927,
   left: 303.595,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box125", 
   isText: false,
   type: "checkbox",
   top: 619.927,
   left: 337.251,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box126", 
   isText: false,
   type: "checkbox",
   top: 619.927,
   left: 369.908,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box127", 
   isText: false,
   type: "checkbox",
   top: 619.927,
   left: 414.554,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box128", 
   isText: false,
   type: "checkbox",
   top: 632.604,
   left: 302.908,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box129", 
   isText: false,
   type: "checkbox",
   top: 671.069,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box130", 
   isText: false,
   type: "checkbox",
   top: 669.008,
   left: 302.221,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box131", 
   isText: false,
   type: "checkbox",
   top: 669.008,
   left: 383.272,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box132", 
   isText: false,
   type: "checkbox",
   top: 680.685,
   left: 303.595,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box133", 
   isText: false,
   type: "checkbox",
   top: 721.8968,
   left: 238.343,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 3,
   name: "Text12", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 163.637,
   left: 57.6003,
   width: 169.6367,
   height: 12.182
}
,
{
   page: 4,
   name: "Age if KnownLight fixtures", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 102.36,
   left: 257.76,
   width: 37.08,
   height: 36.60
}
,
{
   page: 4,
   name: "CommentsLight fixtures", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 102.36,
   left: 297.6,
   width: 290.52,
   height: 36.60
}
,
{
   page: 4,
   name: "Age if KnownSwitches  outlets", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 140.76,
   left: 257.76,
   width: 37.08,
   height: 36.60
}
,
{
   page: 4,
   name: "CommentsSwitches  outlets", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 140.76,
   left: 297.6,
   width: 290.52,
   height: 36.60
}
,
{
   page: 4,
   name: "Age if KnownTelecommunications system equipment or service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 179.16,
   left: 257.76,
   width: 37.08,
   height: 36.84
}
,
{
   page: 4,
   name: "CommentsTelecommunications system equipment or service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 179.16,
   left: 297.6,
   width: 290.52,
   height: 36.84
}
,
{
   page: 4,
   name: "Age if KnownInside wiring  blockjacks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 217.8,
   left: 257.76,
   width: 37.08,
   height: 36.6
}
,
{
   page: 4,
   name: "CommentsInside wiring  blockjacks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 217.8,
   left: 297.6,
   width: 290.52,
   height: 36.6
}
,
{
   page: 4,
   name: "Inside wiring  blockjacks20", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 255.84,
   left: 54.6,
   width: 173.88,
   height: 24.24
}
,
{
   page: 4,
   name: "Age if Known20", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 255.84,
   left: 257.4,
   width: 37.8,
   height: 24.24
}
,
{
   page: 4,
   name: "Comments20", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 255.84,
   left: 297.24,
   width: 291.24,
   height: 24.24
}
,
{
   page: 4,
   name: "Age if KnownElectrical Service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 341.64,
   left: 257.76,
   width: 37.08,
   height: 36.84
}
,
{
   page: 4,
   name: "CommentsElectrical Service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 341.64,
   left: 297.6,
   width: 290.52,
   height: 36.84
}
,
{
   page: 4,
   name: "Age if KnownAluminum wiring at the outlets 110", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 380.28,
   left: 257.76,
   width: 37.08,
   height: 36.60
}
,
{
   page: 4,
   name: "CommentsAluminum wiring at the outlets 110", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 380.28,
   left: 297.6,
   width: 290.52,
   height: 36.60
}
,
{
   page: 4,
   name: "Age if KnownSolar panels", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 418.68,
   left: 257.76,
   width: 37.08,
   height: 36.60
}
,
{
   page: 4,
   name: "CommentsSolar panels", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 418.68,
   left: 297.6,
   width: 290.52,
   height: 36.60
}
,
{
   page: 4,
   name: "Age if KnownWind generators", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 457.08,
   left: 257.76,
   width: 37.08,
   height: 36.60
}
,
{
   page: 4,
   name: "CommentsWind generators", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 457.08,
   left: 297.6,
   width: 290.52,
   height: 36.60
}
,
{
   page: 4,
   name: "Age if KnownElectric Wiring or Panel", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 495.48,
   left: 257.76,
   width: 37.08,
   height: 36.60
}
,
{
   page: 4,
   name: "CommentsElectric Wiring or Panel", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 495.48,
   left: 297.6,
   width: 290.52,
   height: 36.60
}
,
{
   page: 4,
   name: "Electric Wiring or Panel26", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 533.52,
   left: 54.6,
   width: 173.88,
   height: 24.48
}
,
{
   page: 4,
   name: "Age if Known26", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 533.52,
   left: 257.4,
   width: 37.8,
   height: 24.48
}
,
{
   page: 4,
   name: "Comments26", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 533.52,
   left: 297.24,
   width: 291.24,
   height: 24.48
}
,
{
   page: 4,
   name: "Age if KnownElevator", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 615.72,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 4,
   name: "CommentsElevator", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 615.72,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 4,
   name: "Age if KnownLifts or Hoists", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 654.12,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 4,
   name: "CommentsLifts or Hoists", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 654.12,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 4,
   name: "Age if KnownFire suppression andor sprinkler system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 692.52,
   left: 257.52,
   width: 37.08,
   height: 47.16
}
,
{
   page: 4,
   name: "CommentsFire suppression andor sprinkler system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 692.52,
   left: 297.36,
   width: 290.76,
   height: 47.16
}
,
{
   page: 4,
   name: "Check Box134", 
   isText: false,
   type: "checkbox",
   top: 112.646,
   left: 238.716,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box135", 
   isText: false,
   type: "checkbox",
   top: 149.05,
   left: 238.716,
   width: 10.080,
   height: 10.08
}
,
{
   page: 4,
   name: "Check Box136", 
   isText: false,
   type: "checkbox",
   top: 185.454,
   left: 238.716,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box137", 
   isText: false,
   type: "checkbox",
   top: 222.545,
   left: 238.716,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box138", 
   isText: false,
   type: "checkbox",
   top: 259.636,
   left: 238.716,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box139", 
   isText: false,
   type: "checkbox",
   top: 352.363,
   left: 238.716,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box140", 
   isText: false,
   type: "checkbox",
   top: 390.14,
   left: 238.716,
   width: 10.080,
   height: 10.08
}
,
{
   page: 4,
   name: "Check Box141", 
   isText: false,
   type: "checkbox",
   top: 429.978,
   left: 238.716,
   width: 10.080,
   height: 10.081
}
,
{
   page: 4,
   name: "Check Box142", 
   isText: false,
   type: "checkbox",
   top: 469.13,
   left: 238.716,
   width: 10.080,
   height: 10.08
}
,
{
   page: 4,
   name: "Check Box143", 
   isText: false,
   type: "checkbox",
   top: 506.908,
   left: 238.716,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box144", 
   isText: false,
   type: "checkbox",
   top: 540.564,
   left: 238.716,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box145", 
   isText: false,
   type: "checkbox",
   top: 625.735,
   left: 238.716,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box146", 
   isText: false,
   type: "checkbox",
   top: 656.644,
   left: 238.716,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Check Box147", 
   isText: false,
   type: "checkbox",
   top: 702.6645,
   left: 238.716,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 5,
   name: "4_3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 46.631,
   left: 298.019,
   width: 287.669,
   height: 28.075
}
,
{
   page: 5,
   name: "Escalator5", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 77.52,
   left: 54.6,
   width: 173.88,
   height: 24.48
}
,
{
   page: 5,
   name: "E", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 160.467,
   left: 297.452,
   width: 288.116,
   height: 32.483
}
,
{
   page: 5,
   name: "Age if known_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 78.386,
   left: 297.36,
   width: 290.76,
   height: 21.837
}
,
{
   page: 5,
   name: "YesFurnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 46.027,
   left: 256.621,
   width: 38.337,
   height: 28.958
}
,
{
   page: 5,
   name: "Age if knownFurnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 159.72,
   left: 257.52,
   width: 37.08,
   height: 36.84
}
,
{
   page: 5,
   name: "1Row1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 223.414,
   left: 372.32,
   width: 212.561,
   height: 20.525
}
,
{
   page: 5,
   name: "Yesa Furnace Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 78.485,
   left: 257.308,
   width: 35.590,
   height: 21.212
}
,
{
   page: 5,
   name: "Age if knowna Furnace Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 198.36,
   left: 257.52,
   width: 37.08,
   height: 47.64
}
,
{
   page: 5,
   name: "1Row2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 287.278,
   left: 373.694,
   width: 212.561,
   height: 31.465
}
,
{
   page: 5,
   name: "Age if knownb Number of Units", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 247.8,
   left: 257.52,
   width: 37.08,
   height: 36.6
}
,
{
   page: 5,
   name: "Forced Air Gas Forced Air Electric Forced Air Propane Radiant Gravity Flow Other specifyb Number of Units", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 247.8,
   left: 297.36,
   width: 290.76,
   height: 36.6
}
,
{
   page: 5,
   name: "1Row3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 319.496,
   left: 373.007,
   width: 213.935,
   height: 30.715
}
,
{
   page: 5,
   name: "Age if knownc Zoned", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 286.2,
   left: 257.52,
   width: 37.08,
   height: 94.92
}
,
{
   page: 5,
   name: "Age if knownHeating system other than furnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 382.92,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 5,
   name: "Location of zone 1 Location of zone 2 Location of zone 3Heating system other than furnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 382.92,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 5,
   name: "2Row1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 351.213,
   left: 373.007,
   width: 213.935,
   height: 28.717
}
,
{
   page: 5,
   name: "Age if knowna TypeFuel", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 421.32,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 5,
   name: "Location of zone 1 Location of zone 2 Location of zone 3a TypeFuel", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 421.32,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 5,
   name: "Age if knownFree standing Heating Stove", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 459.72,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 5,
   name: "Location of zone 1 Location of zone 2 Location of zone 3Free standing Heating Stove", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 459.72,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 5,
   name: "3Row1_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 507.689,
   left: 371.633,
   width: 213.935,
   height: 34.917
}
,
{
   page: 5,
   name: "Age if knowna Fuel Source", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 498.12,
   left: 257.52,
   width: 37.08,
   height: 46.92
}
,
{
   page: 5,
   name: "Age if knownFireplace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 546.84,
   left: 257.52,
   width: 37.08,
   height: 35.40
}
,
{
   page: 5,
   name: "Wood Pellet Other specify Corn GasFireplace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 546.84,
   left: 297.36,
   width: 290.76,
   height: 35.40
}
,
{
   page: 5,
   name: "4Row1_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 596.764,
   left: 371.753,
   width: 216.443,
   height: 17.843
}
,
{
   page: 5,
   name: "Age if knowna Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 584.4,
   left: 257.28,
   width: 37.56,
   height: 29.52
}
,
{
   page: 5,
   name: "Age if knownb Fireplace starter", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 615.84,
   left: 256.92,
   width: 38.28,
   height: 17.52
}
,
{
   page: 5,
   name: "Switch Remote", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 618.364,
   left: 396.116,
   width: 192.844,
   height: 13.622
}
,
{
   page: 5,
   name: "Age if knownDate fireplacewood stove chimneyflue last cleaned", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 634.68,
   left: 257.04,
   width: 38.04,
   height: 21.72
}
,
{
   page: 5,
   name: "Do not know", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 644.76,
   left: 296.64,
   width: 292.20,
   height: 11.64
}
,
{
   page: 5,
   name: "Age if knownFuel tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 658.2,
   left: 257.52,
   width: 37.08,
   height: 37.56
}
,
{
   page: 5,
   name: "Owned Leased If leased provide the name and contact information of entity leased from_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 679.92,
   left: 296.76,
   width: 291.96,
   height: 15.84
}
,
{
   page: 5,
   name: "Age if knownRadiant heating system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 696.96,
   left: 256.92,
   width: 38.28,
   height: 17.52
}
,
{
   page: 5,
   name: "Age if knowna Interior Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 716.52,
   left: 257.28,
   width: 37.56,
   height: 29.40
}
,
{
   page: 5,
   name: "Interior Exteriora Interior Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 716.52,
   left: 297.12,
   width: 291.24,
   height: 29.40
}
,
{
   page: 5,
   name: "Check Box148", 
   isText: false,
   type: "checkbox",
   top: 57.01,
   left: 236.969,
   width: 10.080,
   height: 10.08
}
,
{
   page: 5,
   name: "Check Box149", 
   isText: false,
   type: "checkbox",
   top: 83.798,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box150", 
   isText: false,
   type: "checkbox",
   top: 173.09,
   left: 237.656,
   width: 10.080,
   height: 10.08
}
,
{
   page: 5,
   name: "Check Box151", 
   isText: false,
   type: "checkbox",
   top: 211.555,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box152", 
   isText: false,
   type: "checkbox",
   top: 258.262,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box153", 
   isText: false,
   type: "checkbox",
   top: 298.787,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box154", 
   isText: false,
   type: "checkbox",
   top: 395.635,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box155", 
   isText: false,
   type: "checkbox",
   top: 428.605,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box156", 
   isText: false,
   type: "checkbox",
   top: 467.756,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box157", 
   isText: false,
   type: "checkbox",
   top: 505.534,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box158", 
   isText: false,
   type: "checkbox",
   top: 499.352,
   left: 302.221,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box159", 
   isText: false,
   type: "checkbox",
   top: 499.352,
   left: 339.999,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box160", 
   isText: false,
   type: "checkbox",
   top: 498.665,
   left: 375.029,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box161", 
   isText: false,
   type: "checkbox",
   top: 499.352,
   left: 407.312,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box162", 
   isText: false,
   type: "checkbox",
   top: 512.402,
   left: 302.908,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box163", 
   isText: false,
   type: "checkbox",
   top: 554.988,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box164", 
   isText: false,
   type: "checkbox",
   top: 588.645,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box165", 
   isText: false,
   type: "checkbox",
   top: 620.241,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box166", 
   isText: false,
   type: "checkbox",
   top: 638.099,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box167", 
   isText: false,
   type: "checkbox",
   top: 664.887,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box168", 
   isText: false,
   type: "checkbox",
   top: 700.6039,
   left: 237.656,
   width: 10.080,
   height: 10.0801
}
,
{
   page: 5,
   name: "Check Box169", 
   isText: false,
   type: "checkbox",
   top: 699.2302,
   left: 302.221,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 5,
   name: "Check Box170", 
   isText: false,
   type: "checkbox",
   top: 699.9171,
   left: 348.928,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 5,
   name: "Check Box171", 
   isText: false,
   type: "checkbox",
   top: 721.2099,
   left: 237.656,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 5,
   name: "Check Box172", 
   isText: false,
   type: "checkbox",
   top: 586.271,
   left: 301.534,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box173", 
   isText: false,
   type: "checkbox",
   top: 585.958,
   left: 349.615,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box174", 
   isText: false,
   type: "checkbox",
   top: 585.21,
   left: 383.272,
   width: 10.080,
   height: 10.08
}
,
{
   page: 5,
   name: "Check Box175", 
   isText: false,
   type: "checkbox",
   top: 585.584,
   left: 452.645,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box176", 
   isText: false,
   type: "checkbox",
   top: 598.261,
   left: 302.908,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box177", 
   isText: false,
   type: "checkbox",
   top: 618.18,
   left: 301.534,
   width: 10.080,
   height: 10.08
}
,
{
   page: 5,
   name: "Check Box178", 
   isText: false,
   type: "checkbox",
   top: 618.18,
   left: 342.06,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Check Box179", 
   isText: false,
   type: "checkbox",
   top: 636.725,
   left: 301.534,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box180", 
   isText: false,
   type: "checkbox",
   top: 660.079,
   left: 300.848,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box181", 
   isText: false,
   type: "checkbox",
   top: 659.392,
   left: 348.241,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box4", 
   isText: false,
   type: "checkbox",
   top: 200.292,
   left: 301.747,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box5", 
   isText: false,
   type: "checkbox",
   top: 200.292,
   left: 372.438,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box6", 
   isText: false,
   type: "checkbox",
   top: 212.728,
   left: 302.401,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box7", 
   isText: false,
   type: "checkbox",
   top: 211.419,
   left: 387.493,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box8", 
   isText: false,
   type: "checkbox",
   top: 212.074,
   left: 430.693,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box9", 
   isText: false,
   type: "checkbox",
   top: 224.51,
   left: 302.401,
   width: 10.080,
   height: 10.08
}
,
{
   page: 6,
   name: "b Exterior Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.28,
   left: 256.64,
   width: 36.724,
   height: 28.80
}
,
{
   page: 6,
   name: "8_4", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 88.334,
   left: 298.259,
   width: 290.624,
   height: 26.346
}
,
{
   page: 6,
   name: "Fuel Provider", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 76.8,
   left: 113.04,
   width: 112.68,
   height: 11.04
}
,
{
   page: 6,
   name: "Fuel Provider_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 77.52,
   left: 256.64,
   width: 36.724,
   height: 38.16
}
,
{
   page: 6,
   name: "Air Conditioning", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 117.12,
   left: 256.64,
   width: 36.724,
   height: 35.76
}
,
{
   page: 6,
   name: "Name and contact informationAir Conditioning", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 117.48,
   left: 297.36,
   width: 290.76,
   height: 35.40
}
,
{
   page: 6,
   name: "9Row1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 46.482,
   left: 296.765,
   width: 290.864,
   height: 28.354
}
,
{
   page: 6,
   name: "a Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 154.32,
   left: 256.64,
   width: 36.724,
   height: 48.96
}
,
{
   page: 6,
   name: "Central Air Age", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 154.32,
   left: 376.92,
   width: 46.08,
   height: 11.04
}
,
{
   page: 6,
   name: "No of Units", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 154.32,
   left: 472.56,
   width: 45.00,
   height: 11.04
}
,
{
   page: 6,
   name: "Other specify", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 180.96,
   left: 416.64,
   width: 159.72,
   height: 11.04
}
,
{
   page: 6,
   name: "b Number of units", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 204.72,
   left: 256.64,
   width: 36.724,
   height: 35.76
}
,
{
   page: 6,
   name: "Central Air Age No of Units Zoned Electric Other specifyb Number of units", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 205.08,
   left: 297.36,
   width: 290.76,
   height: 35.40
}
,
{
   page: 6,
   name: "9Row3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 252.343,
   left: 296.885,
   width: 291.998,
   height: 15.050
}
,
{
   page: 6,
   name: "c Zoned", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 242.04,
   left: 256.64,
   width: 36.724,
   height: 26.04
}
,
{
   page: 6,
   name: "c Zoned10", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 269.64,
   left: 54.72,
   width: 173.64,
   height: 26.52
}
,
{
   page: 6,
   name: "Number of zones10", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 269.64,
   left: 297.12,
   width: 291.24,
   height: 26.52
}
,
{
   page: 6,
   name: "11_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 268.949,
   left: 257.733,
   width: 35.110,
   height: 26.520
}
,
{
   page: 6,
   name: "Age if KnownFurnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 344.04,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 6,
   name: "CommentsFurnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 344.04,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 6,
   name: "Age if KnownHeating system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 382.44,
   left: 257.52,
   width: 37.08,
   height: 36.84
}
,
{
   page: 6,
   name: "CommentsHeating system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 382.44,
   left: 297.36,
   width: 290.76,
   height: 36.84
}
,
{
   page: 6,
   name: "Age if KnownEvaporative cooler", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 421.08,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 6,
   name: "CommentsEvaporative cooler", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 421.08,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 6,
   name: "Age if KnownWindow air conditioning units", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 459.48,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 6,
   name: "CommentsWindow air conditioning units", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 459.48,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 6,
   name: "Age if KnownCentral air conditioning", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 497.88,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 6,
   name: "CommentsCentral air conditioning", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 497.88,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 6,
   name: "Age if KnownAttic fan", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 536.28,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 6,
   name: "CommentsAttic fan", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 536.28,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 6,
   name: "Age if KnownVent fans", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 574.68,
   left: 257.52,
   width: 37.08,
   height: 36.84
}
,
{
   page: 6,
   name: "CommentsVent fans", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 574.68,
   left: 297.36,
   width: 290.76,
   height: 36.84
}
,
{
   page: 6,
   name: "Age if KnownHumidifier", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 613.32,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 6,
   name: "CommentsHumidifier", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 613.32,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 6,
   name: "Age if KnownAir purifier", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 651.72,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 6,
   name: "CommentsAir purifier", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 651.72,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 6,
   name: "Age if KnownFireplace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 690.12,
   left: 257.52,
   width: 37.08,
   height: 36.60
}
,
{
   page: 6,
   name: "CommentsFireplace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 690.12,
   left: 297.36,
   width: 290.76,
   height: 36.60
}
,
{
   page: 6,
   name: "Check Box182", 
   isText: false,
   type: "checkbox",
   top: 157.292,
   left: 302.221,
   width: 10.080,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box183", 
   isText: false,
   type: "checkbox",
   top: 169.282,
   left: 302.221,
   width: 10.080,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box184", 
   isText: false,
   type: "checkbox",
   top: 182.272,
   left: 302.221,
   width: 10.080,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box185", 
   isText: false,
   type: "checkbox",
   top: 183.08,
   left: 344.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Check Box186", 
   isText: false,
   type: "checkbox",
   top: 55.636,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box187", 
   isText: false,
   type: "checkbox",
   top: 89.293,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box188", 
   isText: false,
   type: "checkbox",
   top: 126.383,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box189", 
   isText: false,
   type: "checkbox",
   top: 161.414,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box190", 
   isText: false,
   type: "checkbox",
   top: 216.363,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box191", 
   isText: false,
   type: "checkbox",
   top: 248.646,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box192", 
   isText: false,
   type: "checkbox",
   top: 278.868,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box193", 
   isText: false,
   type: "checkbox",
   top: 353.736,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box194", 
   isText: false,
   type: "checkbox",
   top: 390.14,
   left: 239.03,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Check Box195", 
   isText: false,
   type: "checkbox",
   top: 429.978,
   left: 239.03,
   width: 10.08,
   height: 10.081
}
,
{
   page: 6,
   name: "Check Box196", 
   isText: false,
   type: "checkbox",
   top: 464.322,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box197", 
   isText: false,
   type: "checkbox",
   top: 507.594,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box198", 
   isText: false,
   type: "checkbox",
   top: 542.625,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box199", 
   isText: false,
   type: "checkbox",
   top: 579.715,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box200", 
   isText: false,
   type: "checkbox",
   top: 625.049,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box201", 
   isText: false,
   type: "checkbox",
   top: 658.705,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box202", 
   isText: false,
   type: "checkbox",
   top: 697.8564,
   left: 239.03,
   width: 10.08,
   height: 10.0801
}
,
{
   page: 7,
   name: "21_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.244,
   left: 297.572,
   width: 291.311,
   height: 33.629
}
,
{
   page: 7,
   name: "Fireplace insert", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 45.36,
   left: 257.621,
   width: 35.590,
   height: 37.20
}
,
{
   page: 7,
   name: "22_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 85.44,
   left: 297.572,
   width: 291.311,
   height: 33.629
}
,
{
   page: 7,
   name: "Heating Stove", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 84.0,
   left: 257.621,
   width: 35.590,
   height: 36.96
}
,
{
   page: 7,
   name: "23_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 123.84,
   left: 297.572,
   width: 291.311,
   height: 33.629
}
,
{
   page: 7,
   name: "Fuel tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 122.4,
   left: 257.621,
   width: 35.590,
   height: 36.96
}
,
{
   page: 7,
   name: "Fuel tanks24", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 161.16,
   left: 54.96,
   width: 173.16,
   height: 36.60
}
,
{
   page: 7,
   name: "F", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 161.862,
   left: 257.047,
   width: 37.170,
   height: 31.547
}
,
{
   page: 7,
   name: "known", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 254.015,
   left: 262.53,
   width: 37.95,
   height: 37.680
}
,
{
   page: 7,
   name: "CommentsWater heater", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 254.28,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 7,
   name: "1Row1_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 161.128,
   left: 297.452,
   width: 290.864,
   height: 34.453
}
,
{
   page: 7,
   name: "undefined_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 291.6,
   left: 262.53,
   width: 37.95,
   height: 37.92
}
,
{
   page: 7,
   name: "Commentsa Number of Water Heaters", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 292.68,
   left: 301.92,
   width: 286.20,
   height: 36.84
}
,
{
   page: 7,
   name: "undefined_3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 330.24,
   left: 262.53,
   width: 37.95,
   height: 37.68
}
,
{
   page: 7,
   name: "Commentsb Fuel Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 331.32,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 7,
   name: "undefined_4", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 368.64,
   left: 262.53,
   width: 37.95,
   height: 37.68
}
,
{
   page: 7,
   name: "Commentsc Capacity", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 369.72,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 7,
   name: "Age if knownWater filter system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 408.12,
   left: 262.895,
   width: 37.080,
   height: 54.60
}
,
{
   page: 7,
   name: "Owned Leased If leased provide the name and contact information of entity leased from_4", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 433.92,
   left: 301.68,
   width: 286.68,
   height: 28.80
}
,
{
   page: 7,
   name: "3_4", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 486.844,
   left: 303.633,
   width: 283.309,
   height: 29.289
}
,
{
   page: 7,
   name: "Age if knownWater softener", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 464.52,
   left: 262.08,
   width: 37.08,
   height: 54.36
}
,
{
   page: 7,
   name: "Indicate location of master water shutoff in", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 519.6,
   left: 262.53,
   width: 37.95,
   height: 36.72
}
,
{
   page: 7,
   name: "Owned Leased If leased provide the name and contact information of entity leased fromIndicate location of master water shutoff in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 520.68,
   left: 301.92,
   width: 286.20,
   height: 35.64
}
,
{
   page: 7,
   name: "undefined_5", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 557.04,
   left: 262.53,
   width: 37.95,
   height: 36.48
}
,
{
   page: 7,
   name: "Owned Leased If leased provide the name and contact information of entity leased fromType of well", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 558.12,
   left: 301.92,
   width: 286.20,
   height: 35.40
}
,
{
   page: 7,
   name: "Age if knowna Nonexempt well outside designated groundwater basinirrigation or other uses", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 595.32,
   left: 262.08,
   width: 37.08,
   height: 127.08
}
,
{
   page: 7,
   name: "Well use", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 607.08,
   left: 357.84,
   width: 218.52,
   height: 14.76
}
,
{
   page: 7,
   name: "Permit no", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 622.44,
   left: 361.2,
   width: 215.64,
   height: 14.76
}
,
{
   page: 7,
   name: "Name of augmentation plan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 638.04,
   left: 423.84,
   width: 152.52,
   height: 14.76
}
,
{
   page: 7,
   name: "Well use_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 670.44,
   left: 357.84,
   width: 218.52,
   height: 14.76
}
,
{
   page: 7,
   name: "Permit no 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 686.04,
   left: 359.04,
   width: 217.32,
   height: 14.76
}
,
{
   page: 7,
   name: "Permit no 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 701.64,
   left: 321.36,
   width: 259.08,
   height: 14.76
}
,
{
   page: 7,
   name: "Check Box203", 
   isText: false,
   type: "checkbox",
   top: 54.949,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box204", 
   isText: false,
   type: "checkbox",
   top: 93.414,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box205", 
   isText: false,
   type: "checkbox",
   top: 127.757,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box206", 
   isText: false,
   type: "checkbox",
   top: 170.343,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box207", 
   isText: false,
   type: "checkbox",
   top: 262.383,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box208", 
   isText: false,
   type: "checkbox",
   top: 302.221,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box209", 
   isText: false,
   type: "checkbox",
   top: 340.686,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box210", 
   isText: false,
   type: "checkbox",
   top: 378.464,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box211", 
   isText: false,
   type: "checkbox",
   top: 414.181,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box212", 
   isText: false,
   type: "checkbox",
   top: 409.372,
   left: 307.029,
   width: 10.080,
   height: 10.081
}
,
{
   page: 7,
   name: "Check Box213", 
   isText: false,
   type: "checkbox",
   top: 410.059,
   left: 352.363,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box214", 
   isText: false,
   type: "checkbox",
   top: 466.382,
   left: 306.342,
   width: 10.081,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box215", 
   isText: false,
   type: "checkbox",
   top: 467.069,
   left: 353.049,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box216", 
   isText: false,
   type: "checkbox",
   top: 469.817,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box217", 
   isText: false,
   type: "checkbox",
   top: 525.453,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box218", 
   isText: false,
   type: "checkbox",
   top: 563.231,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box219", 
   isText: false,
   type: "checkbox",
   top: 603.069,
   left: 238.343,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box220", 
   isText: false,
   type: "checkbox",
   top: 596.887,
   left: 307.716,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "Check Box221", 
   isText: false,
   type: "checkbox",
   top: 658.705,
   left: 304.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 8,
   name: "b Nonexempt well inside designated groundwater basin", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 45.48,
   left: 262.771,
   width: 35.789,
   height: 325.80
}
,
{
   page: 8,
   name: "Well use_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 57.48,
   left: 360,
   width: 208.68,
   height: 14.76
}
,
{
   page: 8,
   name: "Permit no_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 74.52,
   left: 363.36,
   width: 204.36,
   height: 14.76
}
,
{
   page: 8,
   name: "Determination case no", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 90.12,
   left: 410.16,
   width: 161.88,
   height: 14.76
}
,
{
   page: 8,
   name: "Well use_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 121.08,
   left: 360.96,
   width: 206.76,
   height: 14.76
}
,
{
   page: 8,
   name: "Permit no_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 136.68,
   left: 364.32,
   width: 203.40,
   height: 14.76
}
,
{
   page: 8,
   name: "Determination case no_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 152.28,
   left: 409.92,
   width: 162.12,
   height: 14.76
}
,
{
   page: 8,
   name: "Well use_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 198.84,
   left: 360.96,
   width: 208.44,
   height: 14.76
}
,
{
   page: 8,
   name: "Permit no_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 214.2,
   left: 363.36,
   width: 204.36,
   height: 14.76
}
,
{
   page: 8,
   name: "Determination case no_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 229.8,
   left: 409.2,
   width: 160.2,
   height: 14.76
}
,
{
   page: 8,
   name: "Well use_6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 261,
   left: 360.96,
   width: 208.44,
   height: 14.52
}
,
{
   page: 8,
   name: "Permit no_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 276.36,
   left: 364.32,
   width: 203.40,
   height: 14.76
}
,
{
   page: 8,
   name: "Determination case no_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 291.96,
   left: 410.16,
   width: 159.24,
   height: 14.76
}
,
{
   page: 8,
   name: "undefined_6", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 372.0,
   left: 261.843,
   width: 38.637,
   height: 37.68
}
,
{
   page: 8,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes NoWell metered", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 373.08,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 8,
   name: "undefined_7", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 410.4,
   left: 261.843,
   width: 38.637,
   height: 37.68
}
,
{
   page: 8,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes NoWell Pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 411.48,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 8,
   name: "Brand name and pump number", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 448.8,
   left: 261.843,
   width: 38.637,
   height: 37.92
}
,
{
   page: 8,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes Noa Brand name and pump number", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 449.88,
   left: 301.92,
   width: 286.20,
   height: 36.84
}
,
{
   page: 8,
   name: "undefined_8", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 487.44,
   left: 261.843,
   width: 38.637,
   height: 37.68
}
,
{
   page: 8,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes Nob Date installed", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 488.52,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 8,
   name: "undefined_9", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 525.84,
   left: 261.843,
   width: 38.637,
   height: 37.68
}
,
{
   page: 8,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes Noc Date of last inspection", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 526.92,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 8,
   name: "undefined_10", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 564.24,
   left: 261.843,
   width: 38.637,
   height: 37.68
}
,
{
   page: 8,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes Nod Date of last service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 565.32,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 8,
   name: "undefined_11", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 602.64,
   left: 261.843,
   width: 38.637,
   height: 37.68
}
,
{
   page: 8,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes Noe Depth", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 603.72,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 8,
   name: "GPM and date last measured", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 641.04,
   left: 261.843,
   width: 38.637,
   height: 37.92
}
,
{
   page: 8,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes Nof GPM and date last measured", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 642.12,
   left: 301.92,
   width: 286.20,
   height: 36.84
}
,
{
   page: 8,
   name: "undefined_12", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 679.68,
   left: 261.843,
   width: 38.637,
   height: 37.68
}
,
{
   page: 8,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes NoGalvanized pipe", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 680.76,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 8,
   name: "SPD19C SELLERS PROPERTY DISCLOSURE COMMERCIAL", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 718.08,
   left: 261.843,
   width: 38.637,
   height: 37.68
}
,
{
   page: 8,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes NoPolybutylene pipe", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 719.16,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 8,
   name: "Check Box222", 
   isText: false,
   type: "checkbox",
   top: 46.02,
   left: 306.342,
   width: 10.081,
   height: 10.08
}
,
{
   page: 8,
   name: "Check Box223", 
   isText: false,
   type: "checkbox",
   top: 111.959,
   left: 305.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box224", 
   isText: false,
   type: "checkbox",
   top: 174.464,
   left: 307.029,
   width: 10.080,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box225", 
   isText: false,
   type: "checkbox",
   top: 254.141,
   left: 307.716,
   width: 10.080,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box226", 
   isText: false,
   type: "checkbox",
   top: 312.211,
   left: 441.655,
   width: 10.080,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box227", 
   isText: false,
   type: "checkbox",
   top: 312.898,
   left: 469.382,
   width: 10.080,
   height: 10.080
}
,
{
   page: 8,
   name: "Text228", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 341.373,
   left: 375.191,
   width: 211.624,
   height: 29.394
}
,
{
   page: 8,
   name: "Check Box229", 
   isText: false,
   type: "checkbox",
   top: 63.192,
   left: 241.09,
   width: 10.08,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box230", 
   isText: false,
   type: "checkbox",
   top: 379.15,
   left: 241.09,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Check Box231", 
   isText: false,
   type: "checkbox",
   top: 419.675,
   left: 241.09,
   width: 10.08,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box232", 
   isText: false,
   type: "checkbox",
   top: 460.201,
   left: 241.09,
   width: 10.08,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box233", 
   isText: false,
   type: "checkbox",
   top: 497.978,
   left: 241.09,
   width: 10.08,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box234", 
   isText: false,
   type: "checkbox",
   top: 536.443,
   left: 241.09,
   width: 10.08,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box235", 
   isText: false,
   type: "checkbox",
   top: 573.534,
   left: 241.09,
   width: 10.08,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box236", 
   isText: false,
   type: "checkbox",
   top: 614.059,
   left: 241.09,
   width: 10.08,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box237", 
   isText: false,
   type: "checkbox",
   top: 653.21,
   left: 241.09,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Check Box238", 
   isText: false,
   type: "checkbox",
   top: 689.614,
   left: 241.09,
   width: 10.08,
   height: 10.0801
}
,
{
   page: 8,
   name: "Check Box383", 
   isText: false,
   type: "checkbox",
   top: 344.484,
   left: 337.15,
   width: 10.08,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box384", 
   isText: false,
   type: "checkbox",
   top: 358.336,
   left: 337.15,
   width: 10.08,
   height: 10.080
}
,
{
   page: 8,
   name: "Check Box10", 
   isText: false,
   type: "checkbox",
   top: 727.8578,
   left: 241.528,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 9,
   name: "Cistern water storage", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 46.184,
   left: 303.366,
   width: 284.225,
   height: 32.942
}
,
{
   page: 9,
   name: "undefined_13", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 44.64,
   left: 262.08,
   width: 37.08,
   height: 37.92
}
,
{
   page: 9,
   name: "10Row1_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 199.394,
   left: 301.573,
   width: 286.056,
   height: 15.667
}
,
{
   page: 9,
   name: "a Number of gallons", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 85.924,
   left: 302.679,
   width: 284.912,
   height: 31.602
}
,
{
   page: 9,
   name: "undefined_14", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 83.28,
   left: 262.08,
   width: 37.08,
   height: 37.68
}
,
{
   page: 9,
   name: "Supplemental water purchased in past 2 years", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 122.537,
   left: 301.992,
   width: 285.599,
   height: 33.389
}
,
{
   page: 9,
   name: "undefined_15", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 121.68,
   left: 262.08,
   width: 37.08,
   height: 37.68
}
,
{
   page: 9,
   name: "11Row1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 161.487,
   left: 301.573,
   width: 285.369,
   height: 34.212
}
,
{
   page: 9,
   name: "Name and contact information of", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 160.08,
   left: 262.08,
   width: 37.08,
   height: 37.68
}
,
{
   page: 9,
   name: "a Name and contact information of entity from which supplemental water was purchased12", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 198.96,
   left: 54.36,
   width: 174.36,
   height: 17.76
}
,
{
   page: 9,
   name: "Known", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 263.52,
   left: 262.08,
   width: 37.08,
   height: 37.92
}
,
{
   page: 9,
   name: "13_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 199.812,
   left: 261.855,
   width: 37.857,
   height: 13.709
}
,
{
   page: 9,
   name: "CommentsWater heaters", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 264.6,
   left: 301.92,
   width: 286.20,
   height: 36.84
}
,
{
   page: 9,
   name: "undefined_16", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 302.16,
   left: 262.08,
   width: 37.08,
   height: 37.68
}
,
{
   page: 9,
   name: "CommentsWater filter system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 303.24,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 9,
   name: "undefined_17", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 340.56,
   left: 262.08,
   width: 37.08,
   height: 37.68
}
,
{
   page: 9,
   name: "CommentsWater softener", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 341.64,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 9,
   name: "undefined_18", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 378.96,
   left: 262.08,
   width: 37.08,
   height: 37.68
}
,
{
   page: 9,
   name: "CommentsWater system pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 380.04,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 9,
   name: "undefined_19", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 417.36,
   left: 262.08,
   width: 37.08,
   height: 37.68
}
,
{
   page: 9,
   name: "CommentsFire sprinkler system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 418.44,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 9,
   name: "undefined_20", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 455.76,
   left: 262.08,
   width: 37.08,
   height: 37.92
}
,
{
   page: 9,
   name: "CommentsBackflow prevention device", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 456.84,
   left: 301.92,
   width: 286.20,
   height: 36.84
}
,
{
   page: 9,
   name: "Backflow prevention device19", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 495.48,
   left: 54.96,
   width: 173.16,
   height: 36.60
}
,
{
   page: 9,
   name: "undefined_21", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 494.4,
   left: 262.08,
   width: 37.08,
   height: 37.68
}
,
{
   page: 9,
   name: "Comments19", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 495.48,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 9,
   name: "systems including lines and water pressure", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 582.24,
   left: 262.08,
   width: 37.08,
   height: 48.72
}
,
{
   page: 9,
   name: "CommentsLeaks backups or other similar problems with any portion of the water or plumbing systems including lines and water pressure or damage therefrom", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 583.32,
   left: 301.92,
   width: 286.20,
   height: 47.64
}
,
{
   page: 9,
   name: "undefined_22", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 631.68,
   left: 262.08,
   width: 37.08,
   height: 37.68
}
,
{
   page: 9,
   name: "CommentsWell", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 632.76,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 9,
   name: "undefined_23", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 670.08,
   left: 262.08,
   width: 37.08,
   height: 37.68
}
,
{
   page: 9,
   name: "CommentsIrrigation system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 671.16,
   left: 301.92,
   width: 286.20,
   height: 36.60
}
,
{
   page: 9,
   name: "undefined_24", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 708.48,
   left: 262.08,
   width: 37.08,
   height: 37.92
}
,
{
   page: 9,
   name: "CommentsWater has been tested for potability", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 709.56,
   left: 301.92,
   width: 286.20,
   height: 36.84
}
,
{
   page: 9,
   name: "Check Box239", 
   isText: false,
   type: "checkbox",
   top: 54.949,
   left: 241.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 9,
   name: "Check Box240", 
   isText: false,
   type: "checkbox",
   top: 92.04,
   left: 241.777,
   width: 10.080,
   height: 10.08
}
,
{
   page: 9,
   name: "Check Box241", 
   isText: false,
   type: "checkbox",
   top: 131.192,
   left: 241.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 9,
   name: "Check Box242", 
   isText: false,
   type: "checkbox",
   top: 166.909,
   left: 241.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 9,
   name: "Check Box243", 
   isText: false,
   type: "checkbox",
   top: 201.939,
   left: 241.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 9,
   name: "Check Box244", 
   isText: false,
   type: "checkbox",
   top: 270.625,
   left: 241.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 9,
   name: "Check Box245", 
   isText: false,
   type: "checkbox",
   top: 309.777,
   left: 241.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 9,
   name: "Check Box246", 
   isText: false,
   type: "checkbox",
   top: 348.928,
   left: 241.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 9,
   name: "Check Box247", 
   isText: false,
   type: "checkbox",
   top: 385.332,
   left: 241.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 9,
   name: "Check Box248", 
   isText: false,
   type: "checkbox",
   top: 425.857,
   left: 241.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 9,
   name: "Check Box249", 
   isText: false,
   type: "checkbox",
   top: 462.261,
   left: 241.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 9,
   name: "Check Box250", 
   isText: false,
   type: "checkbox",
   top: 502.099,
   left: 241.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 9,
   name: "Check Box251", 
   isText: false,
   type: "checkbox",
   top: 593.453,
   left: 241.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 9,
   name: "Check Box252", 
   isText: false,
   type: "checkbox",
   top: 640.846,
   left: 241.777,
   width: 10.080,
   height: 10.081
}
,
{
   page: 9,
   name: "Check Box253", 
   isText: false,
   type: "checkbox",
   top: 677.25,
   left: 241.777,
   width: 10.080,
   height: 10.08
}
,
{
   page: 9,
   name: "Check Box254", 
   isText: false,
   type: "checkbox",
   top: 712.2806,
   left: 241.777,
   width: 10.080,
   height: 10.0801
}
,
{
   page: 10,
   name: "comments and provide the most", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 44.64,
   left: 262.53,
   width: 37.95,
   height: 48.72
}
,
{
   page: 10,
   name: "a Indicate result of test in comments and provide the most recent records and reports pertaining to such testing24", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 94.92,
   left: 54.72,
   width: 173.64,
   height: 26.76
}
,
{
   page: 10,
   name: "undefined_25", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 94.08,
   left: 261.843,
   width: 38.637,
   height: 27.60
}
,
{
   page: 10,
   name: "WATER SUPPLY Provide the following information regarding the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 46.82,
   left: 300.71,
   width: 287.083,
   height: 43.20
}
,
{
   page: 10,
   name: "1_5", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 95.772,
   left: 302.26,
   width: 287.157,
   height: 23.495
}
,
{
   page: 10,
   name: "Is Not provided Well Permit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 171.79,
   left: 450.96,
   width: 135.943,
   height: 15.17
}
,
{
   page: 10,
   name: "CommentsPublic sanitary sewer service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 268.2,
   left: 259.44,
   width: 328.68,
   height: 36.84
}
,
{
   page: 10,
   name: "Commentsa Name and contact information of public sewer service provider", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 306.84,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 10,
   name: "Commentsb Date the sewer line was last scoped", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 345.24,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 10,
   name: "CommentsCommunity sanitary sewer service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 383.64,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 10,
   name: "Commentsa Name and contact information of community sewer service provider", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 422.04,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 10,
   name: "Commentsb Date the sewer line was last scoped_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 460.44,
   left: 259.44,
   width: 328.68,
   height: 36.84
}
,
{
   page: 10,
   name: "If the Property is served by an onsite septic system provide buyer with a copy of the permit", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 521.16,
   left: 259.2,
   width: 329.16,
   height: 27.48
}
,
{
   page: 10,
   name: "Tank Leach Lagoonb Date of issuance of the latest Individual Use Permit", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 569.16,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 10,
   name: "Tank Leach Lagoonc Date of the latest inspection", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 607.56,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 10,
   name: "Tank Leach Lagoond Date of the latest pumping", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 645.96,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 10,
   name: "Yese System is under a maintenance agreement pumpedinspected on a regular basis", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 706.4734,
   left: 260.175,
   width: 325.754,
   height: 12.9492
}
,
{
   page: 10,
   name: "Check Box255", 
   isText: false,
   type: "checkbox",
   top: 57.01,
   left: 239.716,
   width: 10.080,
   height: 10.08
}
,
{
   page: 10,
   name: "Check Box256", 
   isText: false,
   type: "checkbox",
   top: 100.283,
   left: 239.716,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box257", 
   isText: false,
   type: "checkbox",
   top: 162.101,
   left: 142.868,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box258", 
   isText: false,
   type: "checkbox",
   top: 162.101,
   left: 243.151,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box259", 
   isText: false,
   type: "checkbox",
   top: 163.474,
   left: 339.999,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box260", 
   isText: false,
   type: "checkbox",
   top: 161.414,
   left: 377.837,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box261", 
   isText: false,
   type: "checkbox",
   top: 178.585,
   left: 287.11,
   width: 10.08,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box262", 
   isText: false,
   type: "checkbox",
   top: 177.898,
   left: 315.959,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box263", 
   isText: false,
   type: "checkbox",
   top: 193.01,
   left: 132.565,
   width: 10.080,
   height: 10.08
}
,
{
   page: 10,
   name: "Check Box264", 
   isText: false,
   type: "checkbox",
   top: 193.01,
   left: 171.717,
   width: 10.080,
   height: 10.08
}
,
{
   page: 10,
   name: "Check Box265", 
   isText: false,
   type: "checkbox",
   top: 194.07,
   left: 353.049,
   width: 10.080,
   height: 10.08
}
,
{
   page: 10,
   name: "Check Box266", 
   isText: false,
   type: "checkbox",
   top: 193.696,
   left: 390.827,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box267", 
   isText: false,
   type: "checkbox",
   top: 278.868,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box268", 
   isText: false,
   type: "checkbox",
   top: 316.646,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box269", 
   isText: false,
   type: "checkbox",
   top: 354.423,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box270", 
   isText: false,
   type: "checkbox",
   top: 394.261,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box271", 
   isText: false,
   type: "checkbox",
   top: 427.231,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box272", 
   isText: false,
   type: "checkbox",
   top: 470.504,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box273", 
   isText: false,
   type: "checkbox",
   top: 508.968,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box274", 
   isText: false,
   type: "checkbox",
   top: 554.301,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box275", 
   isText: false,
   type: "checkbox",
   top: 553.614,
   left: 263.07,
   width: 10.08,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box276", 
   isText: false,
   type: "checkbox",
   top: 552.928,
   left: 299.474,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box277", 
   isText: false,
   type: "checkbox",
   top: 552.241,
   left: 339.312,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box278", 
   isText: false,
   type: "checkbox",
   top: 580.402,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box279", 
   isText: false,
   type: "checkbox",
   top: 615.432,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 10,
   name: "Check Box280", 
   isText: false,
   type: "checkbox",
   top: 653.21,
   left: 237.656,
   width: 10.080,
   height: 10.08
}
,
{
   page: 10,
   name: "Check Box281", 
   isText: false,
   type: "checkbox",
   top: 690.301,
   left: 237.656,
   width: 10.080,
   height: 10.0799
}
,
{
   page: 10,
   name: "Check Box282", 
   isText: false,
   type: "checkbox",
   top: 686.867,
   left: 263.757,
   width: 10.080,
   height: 10.0796
}
,
{
   page: 10,
   name: "Check Box283", 
   isText: false,
   type: "checkbox",
   top: 718.4625,
   left: 264.444,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 11,
   name: "Other sanitary sewer service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.541,
   left: 291.084,
   width: 296.219,
   height: 35.358
}
,
{
   page: 11,
   name: "TypeGray water storageuse", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 86.76,
   left: 259.44,
   width: 328.68,
   height: 36.84
}
,
{
   page: 11,
   name: "Gray water storageuse6", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 125.16,
   left: 53.76,
   width: 174.60,
   height: 26.52
}
,
{
   page: 11,
   name: "Type6", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 125.16,
   left: 259.2,
   width: 329.16,
   height: 26.52
}
,
{
   page: 11,
   name: "CommentsLeaks backups or other similar problems with any portion of the sewage systems including sewer lines or damage therefrom", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 199.56,
   left: 259.44,
   width: 328.68,
   height: 37.56
}
,
{
   page: 11,
   name: "CommentsLift station sewage ejector pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 238.92,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 11,
   name: "Lift station sewage ejector pump9", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 277.08,
   left: 53.76,
   width: 174.60,
   height: 26.52
}
,
{
   page: 11,
   name: "Comments9", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 277.08,
   left: 259.2,
   width: 329.16,
   height: 26.52
}
,
{
   page: 11,
   name: "CommentsFlooding", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 380.28,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 11,
   name: "CommentsDrainage", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 418.68,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 11,
   name: "CommentsGrading", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 457.08,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 11,
   name: "CommentsWater intrusion in the basement crawl space or other parts of the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 495.48,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 11,
   name: "CommentsRepairs made to control water intrusion in the basement crawl space or other parts of the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 533.88,
   left: 259.44,
   width: 328.68,
   height: 36.84
}
,
{
   page: 11,
   name: "Repairs made to control water intrusion in the basement crawl space or other parts of the Property6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 571.8,
   left: 53.04,
   width: 175.80,
   height: 14.28
}
,
{
   page: 11,
   name: "Comments6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 571.8,
   left: 258.72,
   width: 330.12,
   height: 14.28
}
,
{
   page: 11,
   name: "CommentsDrainage or retention ponds dams storm water detention basins or other similar facilities", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 635.64,
   left: 259.44,
   width: 328.68,
   height: 36.60
}
,
{
   page: 11,
   name: "Drainage or retention ponds dams storm water detention basins or other similar facilities8", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 673.68,
   left: 53.4,
   width: 175.08,
   height: 25.92
}
,
{
   page: 11,
   name: "Comments8", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 673.68,
   left: 259.08,
   width: 329.40,
   height: 25.92
}
,
{
   page: 11,
   name: "Check Box284", 
   isText: false,
   type: "checkbox",
   top: 57.01,
   left: 236.969,
   width: 10.080,
   height: 10.08
}
,
{
   page: 11,
   name: "Check Box285", 
   isText: false,
   type: "checkbox",
   top: 93.414,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 11,
   name: "Check Box286", 
   isText: false,
   type: "checkbox",
   top: 130.505,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 11,
   name: "Check Box287", 
   isText: false,
   type: "checkbox",
   top: 206.747,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 11,
   name: "Check Box288", 
   isText: false,
   type: "checkbox",
   top: 245.898,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 11,
   name: "Check Box289", 
   isText: false,
   type: "checkbox",
   top: 282.989,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 11,
   name: "Check Box290", 
   isText: false,
   type: "checkbox",
   top: 389.453,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 11,
   name: "Check Box291", 
   isText: false,
   type: "checkbox",
   top: 427.918,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 11,
   name: "Check Box292", 
   isText: false,
   type: "checkbox",
   top: 463.635,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 11,
   name: "Check Box293", 
   isText: false,
   type: "checkbox",
   top: 502.099,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 11,
   name: "Check Box294", 
   isText: false,
   type: "checkbox",
   top: 540.564,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 11,
   name: "Check Box295", 
   isText: false,
   type: "checkbox",
   top: 573.534,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 11,
   name: "Check Box296", 
   isText: false,
   type: "checkbox",
   top: 643.594,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 11,
   name: "Check Box297", 
   isText: false,
   type: "checkbox",
   top: 677.937,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 12,
   name: "CommentsIncluded fixtures and equipment", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 103.32,
   left: 259.68,
   width: 328.44,
   height: 36.84
}
,
{
   page: 12,
   name: "CommentsStains on carpet", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 141.96,
   left: 259.68,
   width: 328.44,
   height: 36.60
}
,
{
   page: 12,
   name: "CommentsFloors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 180.36,
   left: 259.68,
   width: 328.44,
   height: 36.60
}
,
{
   page: 12,
   name: "Floors4", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 218.52,
   left: 53.76,
   width: 174.60,
   height: 26.52
}
,
{
   page: 12,
   name: "Comments4", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 218.52,
   left: 259.44,
   width: 328.92,
   height: 26.52
}
,
{
   page: 12,
   name: "CommentsZoning violation variance conditional use violation of an enforceable PUD or non conforming use", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 347.88,
   left: 258,
   width: 330.12,
   height: 36.60
}
,
{
   page: 12,
   name: "CommentsNotice or threat of condemnation proceedings", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 386.28,
   left: 258,
   width: 330.12,
   height: 36.60
}
,
{
   page: 12,
   name: "CommentsNotice of any adverse conditions from any governmental or quasigovernmental agency that have not been resolved", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 424.68,
   left: 258,
   width: 330.12,
   height: 36.60
}
,
{
   page: 12,
   name: "CommentsNotice of zoning action related to the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 463.08,
   left: 258,
   width: 330.12,
   height: 36.60
}
,
{
   page: 12,
   name: "CommentsBuilding code city or county violations", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 501.48,
   left: 258,
   width: 330.12,
   height: 36.84
}
,
{
   page: 12,
   name: "CommentsViolation of restrictive covenants or owners association rules or regulations", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 540.12,
   left: 258,
   width: 330.12,
   height: 36.60
}
,
{
   page: 12,
   name: "CommentsAny building or improvements constructed within the past one year before this Date without approval by the owners association or its designated approving body", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 578.52,
   left: 258,
   width: 330.12,
   height: 55.32
}
,
{
   page: 12,
   name: "CommentsAny additions or alterations made with a Building Permit", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 635.64,
   left: 258,
   width: 330.12,
   height: 36.60
}
,
{
   page: 12,
   name: "CommentsAny additions or nonaesthetic alterations made without a Building Permit", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 674.04,
   left: 258,
   width: 330.12,
   height: 36.60
}
,
{
   page: 12,
   name: "CommentsNotice of ADA complaint or report", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 712.44,
   left: 258,
   width: 330.12,
   height: 36.60
}
,
{
   page: 12,
   name: "Check Box298", 
   isText: false,
   type: "checkbox",
   top: 111.959,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 12,
   name: "Check Box299", 
   isText: false,
   type: "checkbox",
   top: 151.797,
   left: 236.969,
   width: 10.080,
   height: 10.081
}
,
{
   page: 12,
   name: "Check Box300", 
   isText: false,
   type: "checkbox",
   top: 187.515,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 12,
   name: "Check Box301", 
   isText: false,
   type: "checkbox",
   top: 224.605,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 12,
   name: "Check Box302", 
   isText: false,
   type: "checkbox",
   top: 355.11,
   left: 236.969,
   width: 10.080,
   height: 10.08
}
,
{
   page: 12,
   name: "Check Box303", 
   isText: false,
   type: "checkbox",
   top: 394.261,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 12,
   name: "Check Box304", 
   isText: false,
   type: "checkbox",
   top: 429.978,
   left: 236.969,
   width: 10.080,
   height: 10.081
}
,
{
   page: 12,
   name: "Check Box305", 
   isText: false,
   type: "checkbox",
   top: 469.817,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 12,
   name: "Check Box306", 
   isText: false,
   type: "checkbox",
   top: 507.594,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 12,
   name: "Check Box307", 
   isText: false,
   type: "checkbox",
   top: 547.433,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 12,
   name: "Check Box308", 
   isText: false,
   type: "checkbox",
   top: 586.584,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 12,
   name: "Check Box309", 
   isText: false,
   type: "checkbox",
   top: 641.533,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 12,
   name: "Check Box310", 
   isText: false,
   type: "checkbox",
   top: 679.998,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 12,
   name: "Check Box311", 
   isText: false,
   type: "checkbox",
   top: 719.1493,
   left: 236.969,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 13,
   name: "Other legal action related to the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 45.36,
   left: 257.308,
   width: 330.049,
   height: 37.20
}
,
{
   page: 13,
   name: "Any part of the Property leased to others written or oral", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 84.0,
   left: 257.308,
   width: 330.049,
   height: 36.96
}
,
{
   page: 13,
   name: "Archeological or historical designation on the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 122.4,
   left: 257.308,
   width: 330.049,
   height: 36.96
}
,
{
   page: 13,
   name: "Threatened or Endangered species on the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 160.8,
   left: 257.308,
   width: 330.049,
   height: 36.96
}
,
{
   page: 13,
   name: "15_3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 237.488,
   left: 258.42,
   width: 329.503,
   height: 25.834
}
,
{
   page: 13,
   name: "Grandfathered conditions or uses", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 199.2,
   left: 257.308,
   width: 330.049,
   height: 36.96
}
,
{
   page: 13,
   name: "Grandfathered conditions or uses16", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 237.72,
   left: 53.76,
   width: 174.60,
   height: 26.52
}
,
{
   page: 13,
   name: "CommentsAny access problems issues or concerns", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 336.36,
   left: 258.48,
   width: 325.32,
   height: 36.60
}
,
{
   page: 13,
   name: "CommentsRoads trails paths or driveways through the Property used by others", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 374.76,
   left: 258.48,
   width: 325.32,
   height: 36.60
}
,
{
   page: 13,
   name: "CommentsPublic highway or county road bordering the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 413.16,
   left: 258.48,
   width: 325.32,
   height: 36.60
}
,
{
   page: 13,
   name: "CommentsAny proposed or existing transportation project that affects or is expected to affect the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 451.56,
   left: 258.48,
   width: 325.32,
   height: 36.84
}
,
{
   page: 13,
   name: "CommentsEncroachments boundary disputes or unrecorded easements", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 490.2,
   left: 258.48,
   width: 325.32,
   height: 36.6
}
,
{
   page: 13,
   name: "CommentsShared or common areas with adjoining properties including but not limited to walls fences and driveways", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 528.6,
   left: 258.48,
   width: 325.32,
   height: 36.6
}
,
{
   page: 13,
   name: "CommentsRequirements for curb gravelpaving or landscaping", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 567,
   left: 258.48,
   width: 325.32,
   height: 36.6
}
,
{
   page: 13,
   name: "CommentsAny limitations on parking or access due to size number of vehicles or type of vehicles in the past year", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 605.4,
   left: 258.48,
   width: 325.32,
   height: 36.6
}
,
{
   page: 13,
   name: "Any limitations on parking or access due to size number of vehicles or type of vehicles in the past year9", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 643.56,
   left: 53.76,
   width: 174.60,
   height: 26.76
}
,
{
   page: 13,
   name: "Comments9_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 643.56,
   left: 258.24,
   width: 325.80,
   height: 26.76
}
,
{
   page: 13,
   name: "Check Box312", 
   isText: false,
   type: "checkbox",
   top: 55.636,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box313", 
   isText: false,
   type: "checkbox",
   top: 94.101,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box314", 
   isText: false,
   type: "checkbox",
   top: 129.131,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box315", 
   isText: false,
   type: "checkbox",
   top: 169.656,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box316", 
   isText: false,
   type: "checkbox",
   top: 206.06,
   left: 236.282,
   width: 10.080,
   height: 10.08
}
,
{
   page: 13,
   name: "Check Box317", 
   isText: false,
   type: "checkbox",
   top: 244.525,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box318", 
   isText: false,
   type: "checkbox",
   top: 345.494,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box319", 
   isText: false,
   type: "checkbox",
   top: 382.585,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box320", 
   isText: false,
   type: "checkbox",
   top: 422.423,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box321", 
   isText: false,
   type: "checkbox",
   top: 459.514,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box322", 
   isText: false,
   type: "checkbox",
   top: 498.665,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box323", 
   isText: false,
   type: "checkbox",
   top: 538.503,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box324", 
   isText: false,
   type: "checkbox",
   top: 577.655,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box325", 
   isText: false,
   type: "checkbox",
   top: 615.432,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 13,
   name: "Check Box326", 
   isText: false,
   type: "checkbox",
   top: 648.402,
   left: 236.282,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "CommentsHazardous materials on the Property such as radioactive toxic or biohazardous materials asbestos pesticides herbicides wastewater sludge radon methane mill tailings solvents or petroleum products", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 101.16,
   left: 259.2,
   width: 328.92,
   height: 55.32
}
,
{
   page: 14,
   name: "CommentsUnderground storage tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 158.28,
   left: 259.2,
   width: 328.92,
   height: 36.60
}
,
{
   page: 14,
   name: "CommentsAboveground storage tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 196.68,
   left: 259.2,
   width: 328.92,
   height: 36.84
}
,
{
   page: 14,
   name: "CommentsUnderground transmission lines", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 235.32,
   left: 259.2,
   width: 328.92,
   height: 36.60
}
,
{
   page: 14,
   name: "CommentsProperty used as situated on or adjoining a dump landfill or municipal solid waste landfill", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 273.72,
   left: 259.2,
   width: 328.92,
   height: 36.60
}
,
{
   page: 14,
   name: "CommentsMonitoring wells or test equipment", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 312.12,
   left: 259.2,
   width: 328.92,
   height: 36.60
}
,
{
   page: 14,
   name: "CommentsSliding settling upheaval movement or instability of earth or expansive soils on the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 350.52,
   left: 259.2,
   width: 328.92,
   height: 36.60
}
,
{
   page: 14,
   name: "CommentsMine shafts tunnels or abandoned wells on the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 388.92,
   left: 259.2,
   width: 328.92,
   height: 36.60
}
,
{
   page: 14,
   name: "CommentsWithin a governmentally designated geological hazard or sensitive area", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 427.32,
   left: 259.2,
   width: 328.92,
   height: 36.84
}
,
{
   page: 14,
   name: "CommentsWithin a governmentally designated floodplain or wetland area", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 465.96,
   left: 259.2,
   width: 328.92,
   height: 36.60
}
,
{
   page: 14,
   name: "CommentsDead diseased or infested trees or shrubs", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 504.36,
   left: 259.2,
   width: 328.92,
   height: 36.60
}
,
{
   page: 14,
   name: "CommentsEnvironmental assessments studies or reports done involving the physical condition of the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 542.76,
   left: 259.2,
   width: 328.92,
   height: 36.60
}
,
{
   page: 14,
   name: "CommentsUsed for any mining graveling or other natural resource extraction operations such as oil and gas wells", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 581.16,
   left: 259.2,
   width: 328.92,
   height: 36.60
}
,
{
   page: 14,
   name: "CommentsOther environmental problems issues or concerns", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 619.56,
   left: 259.2,
   width: 328.92,
   height: 36.84
}
,
{
   page: 14,
   name: "CommentsGrease or sand pits or traps", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 658.2,
   left: 259.2,
   width: 328.92,
   height: 36.6
}
,
{
   page: 14,
   name: "Grease or sand pits or traps16", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 696.36,
   left: 53.76,
   width: 174.60,
   height: 26.52
}
,
{
   page: 14,
   name: "Comments16", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 696.36,
   left: 258.96,
   width: 329.40,
   height: 26.52
}
,
{
   page: 14,
   name: "Check Box327", 
   isText: false,
   type: "checkbox",
   top: 113.333,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box328", 
   isText: false,
   type: "checkbox",
   top: 165.535,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box329", 
   isText: false,
   type: "checkbox",
   top: 204.686,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box330", 
   isText: false,
   type: "checkbox",
   top: 243.151,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box331", 
   isText: false,
   type: "checkbox",
   top: 281.615,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box332", 
   isText: false,
   type: "checkbox",
   top: 318.706,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box333", 
   isText: false,
   type: "checkbox",
   top: 361.979,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box334", 
   isText: false,
   type: "checkbox",
   top: 395.635,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box335", 
   isText: false,
   type: "checkbox",
   top: 434.787,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box336", 
   isText: false,
   type: "checkbox",
   top: 473.938,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box337", 
   isText: false,
   type: "checkbox",
   top: 513.089,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box338", 
   isText: false,
   type: "checkbox",
   top: 552.928,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box339", 
   isText: false,
   type: "checkbox",
   top: 587.958,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box340", 
   isText: false,
   type: "checkbox",
   top: 628.483,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box341", 
   isText: false,
   type: "checkbox",
   top: 662.826,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 14,
   name: "Check Box342", 
   isText: false,
   type: "checkbox",
   top: 704.7251,
   left: 237.656,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 15,
   name: "CommentsProperty is part of an owners association", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 102.695,
   left: 258.96,
   width: 329.16,
   height: 36.600
}
,
{
   page: 15,
   name: "CommentsSpecial assessments or increases in regular assessments approved by owners association but not yet implemented", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 141.095,
   left: 258.96,
   width: 329.16,
   height: 36.600
}
,
{
   page: 15,
   name: "CommentsProblems issues concerns or defects in the Common Elements or Limited Common Elements of the Association Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 179.495,
   left: 258.96,
   width: 329.16,
   height: 36.600
}
,
{
   page: 15,
   name: "CommentsHas the Association made demand or commenced a lawsuit against a builder or contractor alleging defective construction", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 277.895,
   left: 258.96,
   width: 329.16,
   height: 83.073
}
,
{
   page: 15,
   name: "of improvements of the Association Property common area or property owned or controlled by the Association but outside the Sellers Property or unit5", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 365.375,
   left: 53.64,
   width: 174.84,
   height: 25.920
}
,
{
   page: 15,
   name: "Comments5", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 365.375,
   left: 258.6,
   width: 329.88,
   height: 25.920
}
,
{
   page: 15,
   name: "Contact InformationOwners Association 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 451.175,
   left: 258.96,
   width: 329.16,
   height: 36.840
}
,
{
   page: 15,
   name: "Contact InformationOwners Association 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 489.815,
   left: 258.96,
   width: 329.16,
   height: 36.600
}
,
{
   page: 15,
   name: "Contact InformationOwners Association 3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 528.215,
   left: 258.96,
   width: 329.16,
   height: 36.600
}
,
{
   page: 15,
   name: "Contact InformationOwners Association 4", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 566.615,
   left: 258.96,
   width: 329.16,
   height: 36.600
}
,
{
   page: 15,
   name: "Owners Association 410", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 604.655,
   left: 53.64,
   width: 174.84,
   height: 25.920
}
,
{
   page: 15,
   name: "Contact Information10", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 604.655,
   left: 258.6,
   width: 329.88,
   height: 25.920
}
,
{
   page: 15,
   name: "CommentsProperty is located within the boundaries of a Metropolitan District that was organized on or after January 1 2000", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 692.8548,
   left: 257.76,
   width: 330.60,
   height: 30.1200
}
,
{
   page: 15,
   name: "Property is located within the boundaries of a Metropolitan District that was organized on or after January 1 20002", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 724.8,
   left: 54.84,
   width: 173.88,
   height: 17.76
}
,
{
   page: 15,
   name: "Comments2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 725.6148,
   left: 257.4,
   width: 331.32,
   height: 17.7600
}
,
{
   page: 15,
   name: "Check Box343", 
   isText: false,
   type: "checkbox",
   top: 111.959,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 15,
   name: "Check Box344", 
   isText: false,
   type: "checkbox",
   top: 148.363,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 15,
   name: "Check Box345", 
   isText: false,
   type: "checkbox",
   top: 184.767,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 15,
   name: "Check Box346", 
   isText: false,
   type: "checkbox",
   top: 285.05,
   left: 236.969,
   width: 10.080,
   height: 10.08
}
,
{
   page: 15,
   name: "Check Box347", 
   isText: false,
   type: "checkbox",
   top: 324.201,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 15,
   name: "Check Box348", 
   isText: false,
   type: "checkbox",
   top: 368.847,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 15,
   name: "Check Box349", 
   isText: false,
   type: "checkbox",
   top: 458.14,
   left: 236.969,
   width: 10.080,
   height: 10.08
}
,
{
   page: 15,
   name: "Check Box350", 
   isText: false,
   type: "checkbox",
   top: 496.605,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 15,
   name: "Check Box351", 
   isText: false,
   type: "checkbox",
   top: 532.322,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 15,
   name: "Check Box352", 
   isText: false,
   type: "checkbox",
   top: 578.342,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 15,
   name: "Check Box353", 
   isText: false,
   type: "checkbox",
   top: 611.311,
   left: 236.969,
   width: 10.080,
   height: 10.080
}
,
{
   page: 15,
   name: "Check Box354", 
   isText: false,
   type: "checkbox",
   top: 701.2908,
   left: 238.343,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 15,
   name: "Check Box355", 
   isText: false,
   type: "checkbox",
   top: 728.0786,
   left: 237.656,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 15,
   name: "Text13", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 460.802,
   left: 54.9821,
   width: 172.9089,
   height: 23.309
}
,
{
   page: 15,
   name: "Text14", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 499.42,
   left: 54.9821,
   width: 172.9089,
   height: 23.309
}
,
{
   page: 15,
   name: "Text15", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 537.384,
   left: 54.9821,
   width: 172.9089,
   height: 23.309
}
,
{
   page: 15,
   name: "Text16", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 576.003,
   left: 54.9821,
   width: 172.9089,
   height: 23.309
}
,
{
   page: 16,
   name: "Name of Metropolitan District 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 68.4,
   left: 257.995,
   width: 329.362,
   height: 37.2
}
,
{
   page: 16,
   name: "Official website of the Metropolitan District 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 107.04,
   left: 257.995,
   width: 329.362,
   height: 36.96
}
,
{
   page: 16,
   name: "Name of Metropolitan District 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 145.44,
   left: 257.995,
   width: 329.362,
   height: 36.96
}
,
{
   page: 16,
   name: "6_9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 221.755,
   left: 257.733,
   width: 328.882,
   height: 12.782
}
,
{
   page: 16,
   name: "Official website of Metropolitan District 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 183.84,
   left: 257.995,
   width: 329.362,
   height: 36.96
}
,
{
   page: 16,
   name: "Official website of Metropolitan District 27", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 221.88,
   left: 54.72,
   width: 174.12,
   height: 14.28
}
,
{
   page: 16,
   name: "CommentsWritten reports of any building site roofing soils water sewer mold or engineering investigations or studies of the Property Provide copies of all such reports in possession of Seller", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 296.28,
   left: 259.68,
   width: 328.44,
   height: 55.56
}
,
{
   page: 16,
   name: "CommentsAny property insurance claim submitted whether paid or not", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 353.64,
   left: 259.68,
   width: 328.44,
   height: 36.60
}
,
{
   page: 16,
   name: "CommentsStructural architectural and engineering plans andor specifications for any existing improvements Provide copies of all such reports in possession of Seller", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 392.04,
   left: 259.68,
   width: 328.44,
   height: 55.32
}
,
{
   page: 16,
   name: "CommentsProperty was previously used as a methamphetamine laboratory and not remediated to state standards", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 449.16,
   left: 259.68,
   width: 328.44,
   height: 36.60
}
,
{
   page: 16,
   name: "CommentsGovernment special improvements approved but not yet installed that may become a lien against the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 487.56,
   left: 259.68,
   width: 328.44,
   height: 36.60
}
,
{
   page: 16,
   name: "CommentsAny litigation alleging negligent construction or defective building products", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 525.96,
   left: 259.68,
   width: 328.44,
   height: 74.76
}
,
{
   page: 16,
   name: "CommentsAny award or payment of money in lieu of repairs for defective building products or poor construction", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 602.52,
   left: 259.68,
   width: 328.44,
   height: 36.60
}
,
{
   page: 16,
   name: "CommentsAny release signed regarding defective products or poor construction that would limit a future owner from making a claim", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 640.92,
   left: 259.68,
   width: 328.44,
   height: 36.60
}
,
{
   page: 16,
   name: "CommentsPending 1 litigation or 2 other dispute resolution proceeding regarding the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 679.32,
   left: 259.68,
   width: 328.44,
   height: 36.60
}
,
{
   page: 16,
   name: "CommentsSigns Government or private restriction problems issues or concerns", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 717.72,
   left: 259.68,
   width: 328.44,
   height: 36.84
}
,
{
   page: 16,
   name: "Check Box356", 
   isText: false,
   type: "checkbox",
   top: 79.677,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box357", 
   isText: false,
   type: "checkbox",
   top: 119.515,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box358", 
   isText: false,
   type: "checkbox",
   top: 156.606,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box359", 
   isText: false,
   type: "checkbox",
   top: 190.949,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box360", 
   isText: false,
   type: "checkbox",
   top: 223.232,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box361", 
   isText: false,
   type: "checkbox",
   top: 307.716,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box362", 
   isText: false,
   type: "checkbox",
   top: 359.918,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box363", 
   isText: false,
   type: "checkbox",
   top: 402.504,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box364", 
   isText: false,
   type: "checkbox",
   top: 458.827,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box365", 
   isText: false,
   type: "checkbox",
   top: 497.291,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box366", 
   isText: false,
   type: "checkbox",
   top: 533.695,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box367", 
   isText: false,
   type: "checkbox",
   top: 614.059,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box368", 
   isText: false,
   type: "checkbox",
   top: 647.715,
   left: 237.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Check Box369", 
   isText: false,
   type: "checkbox",
   top: 685.493,
   left: 237.656,
   width: 10.080,
   height: 10.0799
}
,
{
   page: 16,
   name: "Check Box370", 
   isText: false,
   type: "checkbox",
   top: 728.0786,
   left: 237.656,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 17,
   name: "11_5", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 82.214,
   left: 259.107,
   width: 328.882,
   height: 24.699
}
,
{
   page: 17,
   name: "Property is subject to Deed Restrictions other recorded document restrictions or Affordable Housing Restrictions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 45.48,
   left: 259.488,
   width: 328.055,
   height: 37.08
}
,
{
   page: 17,
   name: "Property is subject to Deed Restrictions other recorded document restrictions or Affordable Housing Restrictions12", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 84,
   left: 55.08,
   width: 173.40,
   height: 23.76
}
,
{
   page: 17,
   name: "14_6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 184.443,
   left: 263.795,
   width: 324.314,
   height: 12.060
}
,
{
   page: 17,
   name: "i Other specify", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 196.742,
   left: 335.345,
   width: 254.267,
   height: 12.538
}
,
{
   page: 17,
   name: "US Postal Service delivery available15", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 211.68,
   left: 55.08,
   width: 173.40,
   height: 24.00
}
,
{
   page: 17,
   name: "i Property i Post Office i Cluster MailboxLocation and No i Other specify15", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 212.367,
   left: 259.32,
   width: 329.16,
   height: 22.626
}
,
{
   page: 17,
   name: "Check Box371", 
   isText: false,
   type: "checkbox",
   top: 54.949,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 17,
   name: "Check Box372", 
   isText: false,
   type: "checkbox",
   top: 89.293,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 17,
   name: "Check Box373", 
   isText: false,
   type: "checkbox",
   top: 138.747,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 17,
   name: "Check Box374", 
   isText: false,
   type: "checkbox",
   top: 166.909,
   left: 239.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 17,
   name: "Check Box375", 
   isText: false,
   type: "checkbox",
   top: 217.05,
   left: 239.03,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Check Box376", 
   isText: false,
   type: "checkbox",
   top: 136.747,
   left: 265.13,
   width: 10.08,
   height: 10.080
}
,
{
   page: 17,
   name: "Check Box377", 
   isText: false,
   type: "checkbox",
   top: 136.747,
   left: 309.777,
   width: 10.080,
   height: 10.080
}
,
{
   page: 17,
   name: "Check Box378", 
   isText: false,
   type: "checkbox",
   top: 164.161,
   left: 263.757,
   width: 10.080,
   height: 10.080
}
,
{
   page: 17,
   name: "Check Box379", 
   isText: false,
   type: "checkbox",
   top: 163.474,
   left: 310.464,
   width: 10.080,
   height: 10.080
}
,
{
   page: 17,
   name: "Check Box380", 
   isText: false,
   type: "checkbox",
   top: 176.212,
   left: 263.07,
   width: 10.08,
   height: 10.080
}
,
{
   page: 17,
   name: "Check Box381", 
   isText: false,
   type: "checkbox",
   top: 199.565,
   left: 262.383,
   width: 10.080,
   height: 10.080
}
,
{
   page: 17,
   name: "Text382", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 298.787,
   left: 29.5353,
   width: 562.8067,
   height: 234.929
}
] }
